import {useMemo} from "react";
import COMPONENT_MAP from '../Repository/Components.js';
import NOIMAGE_CUSTOM from "../../assets/no-image.png";

const SKUDetailImages=({parentId,application,userData,parent})=>{

    const renderImageTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ImageTab'];
        return Component?(
            <Component
                parentId={parentId}
                parentTable={'sku'}
                parent={parent}
                application={application}
                userData={userData}
                entityParams={['parent_id='+parentId,'table_name=sku','is_image=True','_lang='+application.globalData.lang]}
                height={'50vh'}
                file={'SKUDetailImages.js'}
                noImage={NOIMAGE_CUSTOM}
            />
        ):null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[parentId]);

    return(renderImageTab);
}
export default SKUDetailImages;